export const daysRegex = /^\d+ days$/;

export const POSTFIX = 'days';

export const DAY = 'day';
